import {
  CloudDownload as DownloadIcon,
  Comment as CommentIcon,
  Contacts as ContactPersonIcon,
  Group as CustomerIcon,
  Timeline as HistoryIcon,
} from "@mui/icons-material";
import { SpeedDial, SpeedDialAction } from "@mui/material";
import { useState } from "react";
import { useDownloadFile } from "../../components/downloadFileButton/useDownloadFile";
import { useSnackbar } from "notistack";
import { getCustomerContactPersonCsv, getCustomerNotesCsv, getCustomersCsv } from "./customersCsvApi";
import { getCustomersOrdersHistoryCsv } from "../customersApi";

enum OptionNames {
  CUSTOMERS = "customers",
  CUSTOMER_CONTACT_PERSON = "customerContactPerson",
  CUSTOMER_NOTES = "customerNotes",
  CUSTOMER_ORDERS_HISTORY = "customerOrdersHistory",
}

const options = [
  {
    name: OptionNames.CUSTOMERS,
    apiDefinition: getCustomersCsv,
    filename: "klienci.csv",
  },
  {
    name: OptionNames.CUSTOMER_CONTACT_PERSON,
    apiDefinition: getCustomerContactPersonCsv,
    filename: "klienci - osoby kontaktowe.csv",
  },
  {
    name: OptionNames.CUSTOMER_NOTES,
    apiDefinition: getCustomerNotesCsv,
    filename: "klienci - notatki.csv",
  },
  {
    name: OptionNames.CUSTOMER_ORDERS_HISTORY,
    apiDefinition: getCustomersOrdersHistoryCsv,
    filename: "klienci - historia zamowien.csv",
  },
];

export const CustomerCsv = () => {
  const { enqueueSnackbar } = useSnackbar();
  const { download, isLoading } = useDownloadFile({
    apiDefinition: (key) => {
      const def = options.find((o) => o.name === key)?.apiDefinition;
      if (!def) {
        throw new Error(`No CSV download option for key ${key}`);
      }
      return def();
    },
    onError: (error) => {
      enqueueSnackbar(`Nie udało się pobrać CSV. Powód: ${(error as Error).message}`, { variant: "error" });
    },
    filename: (key) => options.find((o) => o.name === key)?.filename ?? "klienci.csv",
  });
  const [open, setOpen] = useState(false);

  return (
    <SpeedDial
      icon={<DownloadIcon />}
      ariaLabel="Eksport do CSV"
      direction="up"
      FabProps={{ color: "secondary" }}
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
      open={open}
    >
      {open && (
        <SpeedDialAction
          aria-disabled={isLoading}
          icon={<CustomerIcon />}
          slotProps={{
            tooltip: { title: "CSV z listą klientów" },
          }}
          onClick={() => download(OptionNames.CUSTOMERS)}
        />
      )}
      {open && (
        <SpeedDialAction
          aria-disabled={isLoading}
          icon={<ContactPersonIcon />}
          slotProps={{
            tooltip: { title: "CSV z osobami kontaktowymi klientów" },
          }}
          onClick={() => download(OptionNames.CUSTOMER_CONTACT_PERSON)}
        />
      )}
      {open && (
        <SpeedDialAction
          aria-disabled={isLoading}
          icon={<CommentIcon />}
          slotProps={{ tooltip: { title: "CSV z notatkami klientów" } }}
          onClick={() => download(OptionNames.CUSTOMER_NOTES)}
        />
      )}
      {open && (
        <SpeedDialAction
          icon={<HistoryIcon />}
          slotProps={{ tooltip: { title: "CSV z historią zamówień klientów" } }}
          onClick={() => download(OptionNames.CUSTOMER_ORDERS_HISTORY)}
        />
      )}
    </SpeedDial>
  );
};
